module.exports = __webpack_public_path__ + "img/silos_amasadoras_y_lanzadoras_para_construccion.60f98fb4.png";